/**
 * Attribution Survey — checkout gate
 *
 * WHAT IT DOES:
 *   1. Visually flags any Checkout button (button/input with name="checkout") as
 *      locked (CSS class only — does NOT set/remove the native "disabled"
 *      attribute) until a radio in the attribution-survey snippet is selected.
 *      IMPORTANT: it deliberately avoids touching the native "disabled" attribute
 *      so it doesn't conflict with any other script (e.g. a required-checkbox
 *      gate) that also manages that attribute on the same button. Both gates can
 *      run independently this way — checkout only proceeds if BOTH pass.
 *   2. Saves the answer to the cart as soon as it's selected (not at click-time),
 *      via /cart/update.js, as a cart attribute called "How did you hear about us?"
 *      — this automatically carries through to become an order attribute after
 *      purchase.
 *   3. On checkout click, only ever BLOCKS (if unanswered) — never proceeds on
 *      the customer's behalf. If answered, it does nothing and lets the native
 *      click/form-submit continue exactly as it would without this script, so
 *      any other click/submit handlers on the same button (like policy-checkbox
 *      validation) always still run untouched.
 */
(function () {
  var STORAGE_KEY = 'attributionSurveyAnswer';

  function getSelected() {
    var checked = document.querySelector('input[name="attribution_survey"]:checked');
    if (checked) return checked.value;
    return sessionStorage.getItem(STORAGE_KEY);
  }

  function setButtonsVisualState(enabled) {
    document
      .querySelectorAll('button[name="checkout"], input[name="checkout"]')
      .forEach(function (btn) {
        if (enabled) {
          btn.classList.remove('attribution-survey-locked');
        } else {
          btn.classList.add('attribution-survey-locked');
        }
      });
  }

  function syncRadiosFromStorage() {
    var saved = sessionStorage.getItem(STORAGE_KEY);
    if (!saved) return;
    document
      .querySelectorAll('input[name="attribution_survey"]')
      .forEach(function (r) {
        if (r.value === saved) r.checked = true;
      });
  }

  function saveAttributeToCart(answer) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'How did you hear about us?': answer }
      })
    }).catch(function () {});
  }

  function onRadioChange(e) {
    if (!e.target || e.target.name !== 'attribution_survey') return;
    sessionStorage.setItem(STORAGE_KEY, e.target.value);
    saveAttributeToCart(e.target.value);
    setButtonsVisualState(true);
    document
      .querySelectorAll('[data-attribution-hint]')
      .forEach(function (el) { el.hidden = true; });
  }

  function onCheckoutClick(e) {
    var answer = getSelected();
    if (answer) return;
    e.preventDefault();
    e.stopPropagation();
    document
      .querySelectorAll('[data-attribution-hint]')
      .forEach(function (el) { el.hidden = false; });
    var el = document.getElementById('attribution-survey');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function bindCheckoutButtons() {
    document
      .querySelectorAll('button[name="checkout"], input[name="checkout"]')
      .forEach(function (btn) {
        btn.removeEventListener('click', onCheckoutClick);
        btn.addEventListener('click', onCheckoutClick);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncRadiosFromStorage();
    setButtonsVisualState(!!getSelected());
    document.addEventListener('change', onRadioChange);
    bindCheckoutButtons();
  });

  document.addEventListener('cart:updated', function () {
    setButtonsVisualState(!!getSelected());
    bindCheckoutButtons();
  });
})();